import { postLogingress } from '~/utils/logingress/logingress';
import {
  appointmentClinicBannerStorage,
  appointmentDraftStorage,
  medicoUserStorage,
} from '~/utils/storage/ubieAppStorage';
import { getMedicalInstitutionAppointmentPreference } from '~/constants/medicalInstitutionAppointmentPreferences';
import { getOfroFlags } from '~/services/OfroFlagService';
import { MedicalInstitutionForAppointmentFragment } from '../../../gen/medinavi-backend-consumer-graphql/graphql';

const generateParams = () => {
  const medicoUser = medicoUserStorage.get();

  let sex;
  if (medicoUser?.medicoUser.sex?.toLowerCase() === 'male') {
    sex = 1;
  } else if (medicoUser?.medicoUser.sex?.toLowerCase() === 'female') {
    sex = 2;
  } else {
    sex = null;
  }

  return {
    medico_user_id: medicoUser?.medicoUser.id,
    medico_client_id: medicoUser?.medicoUser.medicoClientId,
    signed_in_service_name: medicoUser?.authProvider,
    age: medicoUser?.medicoUser.age,
    sex,
    browser_language: (window.navigator.languages && window.navigator.languages[0]) || window.navigator.language,
    // 以下は現時点では固定だが、多言語化したり、アプリ対応した場合は変更する必要あり
    language: 'japanese',
    country: 'japan',
    platform: 'web',
    is_developer: getOfroFlags().isDeveloper ?? false,
  };
};

export const sendBookingPageViewToLogingress = async () => {
  const visitFrom = appointmentClinicBannerStorage.get()?.visitFrom ?? null;
  const content = JSON.stringify({ visitFrom });

  await postLogingress({
    ...generateParams(),
    log_type: 'booking_patient_page_view',
    referrer: (document.referrer ?? '').length !== 0 ? document.referrer : null,
    browser_language: (window.navigator.languages && window.navigator.languages[0]) || window.navigator.language,
    content,
  });
};

export const sendBookingEventToLogingress = async (
  eventName: string,
  medicalInstitution: MedicalInstitutionForAppointmentFragment,
  eventParams: object = {},
) => {
  // 予約関連の基本情報をログに自動的に含める
  const pref = getMedicalInstitutionAppointmentPreference(medicalInstitution);
  const isTelAppointment = pref.type === 'requestAppointment';
  const reservation = appointmentDraftStorage.get();
  const menuIndex = reservation?.menuIndex;
  const menu = menuIndex != null ? pref.menus[menuIndex] : undefined;
  const visitFrom = appointmentClinicBannerStorage.get()?.visitFrom ?? null;

  const content = JSON.stringify({
    ...eventParams,
    isTelAppointment,
    menuIndex,
    menu,
    visitFrom,
  });
  await postLogingress({
    ...generateParams(),
    log_type: 'booking_patient_event',
    event_name: eventName,
    medical_institution_id: medicalInstitution.id,
    content,
  });
};
